import { createSelector } from 'reselect';
import { getTr } from '../../../ReportByUTM/ReportByUTM.selectors';
import ReportByUTMComponent from '../../../../utils/ReportByUTMComponent/ReportByUTMComponent';
import resolveMetricsConfig from '../../../../helpers/reportMetrics';
import store from '../../../../stores/redux';

const reportUtils = ReportByUTMComponent.utils;

const buildMetricsConfig = (parameters = {}, location = {}, reportMetricsValue = '') =>
    resolveMetricsConfig(parameters, location, reportMetricsValue, reportUtils);

const rows = (state) => state.statistics.data.rows;
const totals = (state) => state.statistics.data.totals;
const parameters = (state) => state.statistics.data.parameters;
const location = (state) => state.routing?.location || state.routing?.locationBeforeTransitions || {};
const offers = (state) => state.offers.list;
const goals = (state) => state.goals.list;
const links = (state) => state.links.list;
const regions = (state) => state.regions.list;
const report = (state) => state.statistics.data.parameters.metricsBinary || state.serverStorage.store.reportByUTM?.metrics || state.serverStorage.store.report?.metrics;
let oldRows = rows(store.getState());

export const mainSelector = createSelector(
    rows,
    totals,
    parameters,
    offers,
    goals,
    links,
    regions,
    (rows = [], totals = {}, parameters = {}, offers = [], goals = [], links = [], regions = []) => {
        let data = '';

        const newParameters = {
            ...parameters,
            isChange: oldRows !== rows,
            isHtml: false
        };
        oldRows = rows;

        rows.map((item) => {
            data += getTr(item, newParameters);
        });

        if (Object.keys(totals).length) {
            data += getTr(totals, newParameters, true);
        }

        return data;
    }
);

export const getHeaderName = createSelector(
    parameters,
    location,
    report,
    (parameters = {}, location = {}, report) => {
        reportUtils.setKeyGroupBy(parameters.group_by || (location.query && location.query.groupBy));
        let headerNames = reportUtils.getMultiLevelHeaderNames();
        const metricsConfig = buildMetricsConfig(parameters, location, report && report.metrics);
        let visibleKeysMetric = metricsConfig.keys;

        reportUtils.updateVisible(headerNames, visibleKeysMetric);

        return headerNames;
    }
);

export const getMetrics = createSelector(
    parameters,
    location,
    report,
    (parameters = {}, location = {}, report) => {
        return buildMetricsConfig(parameters, location, report && report.metrics).binary;
    }
);

export const getKeysMetric = createSelector(
    parameters,
    location,
    report,
    (parameters = {}, location = {}, report) => {
        return buildMetricsConfig(parameters, location, report && report.metrics).keys;
    }
);

export const getRowsCount = createSelector(
    rows,
    (rows = []) => {
        return rows.length;
    }
);
